import { css, html, LitElement, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import "@/components/button";
import "@/components/icon";
import "@/components/shortcut";

@customElement("eko-shell-search")
class ShellSearch extends LitElement {
  static styles = css`
    :host {
      display: contents;
    }

    eko-button {
      --eko-button-font-weight: var(--eko-t-font-weight-regular);
      --eko-button-color: oklch(var(--eko-t-color-icon));
      --eko-button-text-align: left;
      --eko-button-background-color: color-mix(
        in srgb,
        oklch(var(--eko-t-color-border)),
        transparent 20%
      );
      --eko-button-border-color: transparent;
      --eko-button-box-shadow: none;

      --eko-shortcut-border-color: oklch(var(--eko-t-color-border-alpha));
      --eko-shortcut-color: oklch(var(--eko-t-color-icon));

      height: 29px;
    }

    eko-button[square] {
      --eko-button-inline-size: 32px;
      --eko-button-background-color: initial;
      --eko-button-border-color: initial;
      --eko-button-box-shadow: initial;

      height: auto;
    }

    eko-button:hover {
      --eko-button-background-color: oklch(var(--eko-t-color-border));
      --eko-button-icon-color: oklch(var(--eko-t-color-icon));
    }
  `;

  @state() private compact = false;

  private mq?: MediaQueryList;

  private onMqChange = ({ matches }: MediaQueryListEvent) => {
    this.compact = matches;
  };

  connectedCallback() {
    super.connectedCallback();
    this.mq = window.matchMedia("(max-width: 639px)");
    this.mq.addEventListener("change", this.onMqChange);
    Promise.resolve().then(() => {
      this.compact = this.mq!.matches;
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.mq?.removeEventListener("change", this.onMqChange);
  }

  render() {
    return html`
      <eko-button ?expand=${!this.compact} ?square=${this.compact}>
        <eko-icon name="search-lg" slot="before"></eko-icon>
        ${!this.compact ? html`Search<eko-shortcut slot="after" ctrl>K</eko-shortcut>` : nothing}
      </eko-button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-shell-search": ShellSearch;
  }
}

export default ShellSearch;
